module.exports = __webpack_public_path__ + "assets/media/lunch.6521d38c.mp3";